import { InfoOutlineIcon } from '@carboncopyco/icons';
import type { IVariable } from '@carboncopyco/types';
import { ColorHex, TextBase, TextCaption, Tooltip } from '@carboncopyco/ui';
import type React from 'react';
import { useRef } from 'react';
import { VariableIcon } from '../VariableIcon';

export interface VariableInputFieldProps {
  variable: IVariable;
  children: React.ReactNode;
}

export const VariableInputField = ({
  variable,
  children,
}: VariableInputFieldProps) => {
  const infoRef = useRef(null);

  return (
    <div className="w-full flex mb-3">
      <div className="w-ds-42 flex items-center gap-2 pr-3">
        <VariableIcon
          type={variable.type}
          size="sm"
        />
        <div className="inline-flex overflow-hidden">
          <TextBase
            label={variable.name}
            ellipsis
          />
        </div>
        {variable.description && (
          <>
            <div
              className="ml-0.5"
              ref={infoRef}
            >
              <InfoOutlineIcon
                size={16}
                color={ColorHex.natural}
              />
            </div>
            <Tooltip
              placement="bottom"
              trigger="mouseenter"
              hideOnClick="toggle"
              anchorRef={infoRef}
            >
              <div className="py-2 px-2.5">
                <TextCaption label={variable.description} />
              </div>
            </Tooltip>
          </>
        )}
      </div>
      <div className="flex-1 border-ds-natural-50">{children}</div>
    </div>
  );
};
